import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledRegistrationButton = styled(Link)`
  &#registration-button {
    width: 100%;
    Button {
      font-family: sans-serif;
      font-size: 18px;
      padding: 20px;
      height: 50px;
      width: 100%;
    }
  }
`;

export default StyledRegistrationButton;
